import { ActionReducerMap } from '@ngrx/store';
import { AppState } from 'src/app/store/state/app.state';
import { contenidoReducer } from 'src/app/store/reducers/content-reducer/content.reducer';
import { maestrosReducer } from 'src/app/store/reducers/maestros-reducer/maestros.reducer';
import { pagoReducer } from 'src/app/store/reducers/pago-reducer/pago.reducer';

export const reducers: ActionReducerMap<AppState> = {
  maestros: maestrosReducer,
  pago: pagoReducer,
  contenido: contenidoReducer,
};
